<template>
  <div class="configurationList">
    <div class="configurationList_selectionArea">
      <div class="box-left">
        <el-input v-model="parameter.equipment_code" placeholder="请输入手机设备编码" style="width: 200px;" />
        <el-input v-model="parameter.phone_vx_account" placeholder="请输入微信号" style="width: 200px; " />
        <el-input v-model="parameter.phone_name" placeholder="请输入手机编号" style="width: 200px; " />
        <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button type="info" icon="el-icon-refresh-right" @click="reset">重置</el-button>
      </div>
      <div>
        <el-button type="success" icon="el-icon-plus" @click="dialogVisible = true">创建</el-button>
      </div>

    </div>
    <div class="configurationList_main">
      <el-table
        v-loading="loading"
        :data="tableData.list"
        border
        style="width: 100%"
      >
        <el-table-column
          prop="id"
          label="id"
          align="center"
          min-width="100"
        />
        <el-table-column
          prop="equipment_code"
          label="手机设备编码"
          align="center"
          min-width="120"
        />
        <el-table-column
          prop="phone_name"
          label="手机编号"
          align="center"
          min-width="120"
        />
        <el-table-column
          prop="phone_vx_account"
          label="微信号"
          align="center"
          min-width="100"
        />
        <el-table-column
          prop="admin_id"
          label="创建人"
          align="center"
          min-width="100"
        />
        <el-table-column
          prop="connection_status"
          label="链接状态"
          align="center"
          min-width="100"
        >
          <template scope="scope">
            <span v-if="scope.row.connection_status === 1"><i class="el-icon-error err" />断开链接</span>
            <span v-else-if="scope.row.connection_status === 2"><i class="el-icon-success normal" />链接中</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="last_connection_time"
          label="最后心跳时间"
          align="center"
          min-width="100"
        />
        <el-table-column
          prop="status"
          label="状态"
          align="center"
          min-width="100"
        >
          <template scope="scope">
            <span v-if="scope.row.status === 1"><i
              class="el-icon-success normal"
            />正常</span>
            <span v-else-if="scope.row.status === 2"><i class="el-icon-error err" />停用</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="lock_screen_password"
          label="锁屏密码"
          align="center"
          min-width="100"
        />
        <el-table-column
          prop="wechat_pwd"
          label="微信密码"
          align="center"
          min-width="100"
        />
        <el-table-column prop="name" label="操作" min-width="180" align="center">
          <template scope="scope">
            <div class="btn-wrap-box">
              <el-button type="warning" size="mini" @click="modifyItem(scope.row)">修改</el-button>
              <el-button type="danger" size="mini" @click="deleteItem(scope.row)">删除</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <PaginationRight
        :total="tableData.total"
        :page-sizes="[15]"
        @size-change="fetchPageSizeone"
        @current-change="fetchCurrentPageone"
      />
    </div>

    <el-dialog
      :title="Object.keys(currentItem).length ? '修改' : '创建'"
      :visible.sync="dialogVisible"
      :before-close="handleClose"
    >
      <Details v-if="dialogVisible" :current-item="currentItem" @determine="determine" @close="dialogVisible = false" />
    </el-dialog>
  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight'
import Details from './components/details.vue'
import { mobilePhoneList, mobilePhoneAddition, mobilePhoneModification, mobilePhoneDeletion } from '@/api/enterpriseWeChatCustomerService'
export default {
  components: {
    PaginationRight,
    Details
  },
  data() {
    return {
      parameter: {
        equipment_code: null, // 手机设备编码
        phone_vx_account: null, // 微信号
        phone_name: null, // 手机编号
        page: 1,
        pageSize: 15
      },
      tableData: {},
      loading: false,
      currentItem: {},
      dialogVisible: false
    }
  },
  created() {
    this.getList()
  },
  methods: {

    async getList() {
      this.loading = true
      const data = await mobilePhoneList(this.parameter)
      this.tableData = data.data
      this.loading = false
    },

    // 删除
    async deleteItem(row) {
      this.$confirm('是否确定删除该手机信息', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(async() => {
        await mobilePhoneDeletion({ id: row.id })
        this.getList()
        this.$message({
          message: '删除成功',
          type: 'success'
        })
      })
    },

    // 修改
    modifyItem(row) {
      this.currentItem = row
      this.dialogVisible = true
    },

    // 搜索
    search() {
      this.parameter.page = 1
      this.parameter.pageSize = 10
      this.getList()
    },

    // 重置
    reset() {
      this.parameter.page = 1
      this.parameter.pageSize = 10
      this.parameter.equipment_code = null
      this.parameter.phone_vx_account = null
      this.parameter.phone_name = null
      this.getList()
    },

    // 确定
    async determine(form) {
      const bool = !!Object.keys(this.currentItem).length
      bool ? await mobilePhoneModification({ id: this.currentItem.id, ...form }) : await mobilePhoneAddition(form)
      this.currentItem = {}
      this.dialogVisible = false
      this.getList()
      this.$message({
        message: bool ? '修改成功' : '创建成功',
        type: 'success'
      })
    },

    // 关闭
    handleClose(done) {
      this.dialogVisible = false
      this.currentItem = {}
    },

    fetchPageSizeone(e) {
      this.parameter.page_size = e
      this.getList()
    },

    fetchCurrentPageone(e) {
      this.parameter.page = e
      this.getList()
    }
  }
}
</script>

<style scoped>
.configurationList{
   width: 95%;
   margin: 0 auto;
   margin-top: 30px;
}

.configurationList_selectionArea{
   display: flex;
   justify-content: space-between;
   gap:10px;
}

.configurationList_main{
   margin-top: 30px;
}

.err {
    color: #caae24;
    font-size: 14px;
    margin-right: 6px;
}

.normal {
  color: #5fc922;
  font-size: 16px;
  margin-right: 6px;
}
.box-left{
  display:flex;
  flex-wrap:wrap;
  gap:10px;
}
</style>
